<template>
  <SettingsLayout :role="role" @select="handleSelect" :user="user" @update-prfile="handleUpdate">
    <component :is="currentComponent" :profile="profile" @update-profile="handleUpdate" />
  </SettingsLayout>
</template>

<script>
import { markRaw } from "vue";
import TutorProfileForm from "@/components/settings/tutor/TutorProfileForm.vue";
import SettingsLayout from "@/layout/SettingsLayout.vue";
import TutorSecurityForm from "@/components/settings/tutor/TutorSecurityForm.vue";
import TutorExperiencesForm from "@/components/settings/tutor/TutorExperiencesForm.vue";
import TutorQualificationForm from "@/components/settings/tutor/TutorQualificationForm.vue";
import TutorTeachingForm from "@/components/settings/tutor/TutorTeachingForm.vue";
import TutorPhotoForm from "@/components/settings/tutor/TutorPhotoForm.vue";
import TutorSubscriptionPage from "@/components/settings/tutor/subscription/SubscriptionPage.vue";
import TutorBankInfoPage from "@/components/settings/tutor/TutorBankInfoForm.vue";
import TutorPaymentMethodPage from "@/components/settings/tutor/TutorPaymentMethodPage.vue";
import { useAuthStore } from "@/stores/authStore";
import { getProfile, updateProfile } from "@/api/tutor";
import { useRouter } from "vue-router";
import { notifyError, notifySuccess } from "@/utils/notification";

export default {
  components: {
    SettingsLayout,
  },
  data() {
    return {
      userId: undefined,
      role: "tutor",
      user: null,
      currentComponent: markRaw(TutorProfileForm),
      currentComponentKey: 0,
      componentMap: {
        TutorProfileForm: markRaw(TutorProfileForm),
        TutorSecurityForm: markRaw(TutorSecurityForm),
        TutorExperiencesForm: markRaw(TutorExperiencesForm),
        TutorQualificationForm: markRaw(TutorQualificationForm),
        TutorTeachingForm: markRaw(TutorTeachingForm),
        TutorPhotoForm: markRaw(TutorPhotoForm),
        TutorSubscriptionPage: markRaw(TutorSubscriptionPage),
        TutorBankInfoPage: markRaw(TutorBankInfoPage),
        TutorPaymentMethodPage: markRaw(TutorPaymentMethodPage),
      },
    };
  },
  mounted() {
    this.userId = useAuthStore().user.userId;
    if (!this.userId) {
      this.userId = useAuthStore().user._id;
    }
    if (!this.userId) {
      useRouter().push("/login")
      return
    }
    this.role = useAuthStore().user.role;
    this.user = useAuthStore().user;
    this.fetchUserData();
  },
  computed: {
    profile() {
      return useAuthStore().user;
    }
  },
  methods: {
    async fetchUserData() {
      const user = await getProfile();
      useAuthStore().updateLocalUser(user.data.data);
    },
    async handleUpdate(payload) {
      try {
        await updateProfile(payload);
        notifySuccess("Success", "Your profile has been updated.");
        await this.fetchUserData();
      } catch {
        notifyError("Oops! Something went wrong", "We couldn’t complete your request. Please try again or contact support if the problem persists.");
      }
    },
    handleSelect(componentName) {
      if (this.componentMap[componentName]) {
        this.currentComponent = this.componentMap[componentName];
        this.currentComponentKey += 1; // force remount only when you intentionally switch
      }
    },
  },
};
</script>
